import React, { useState, useEffect, useRef, useCallback } from "react";

import {
  AppLayout,
  Badge,
  Box,
  BreadcrumbGroup,
  Button,
  ColumnLayout,
  Container,
  Tabs,
  Grid,
  Header,
  HelpPanel,
  Icon,
  Modal,
  SpaceBetween,
  Spinner,
  Alert,
  Table,
  ExpandableSection,
  Flashbar,
  StatusIndicator,
  Link,
  Multiselect,
  Textarea,
  FormField,
  Checkbox
} from "@amzn/awsui-components-react";
import { useBreadcrumb } from '../generic-components/Breadcrumb/useBreadcrumb';
import { useHistory, useParams } from "react-router-dom";
import * as XLSX from "xlsx";

import * as d3 from "d3";

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";

import { API, graphqlOperation } from "aws-amplify";
import { Storage } from "aws-amplify";
import SideNav from "./SideNav";
import { getWasWorkflowById, performActionOnWorkflow, getAllowedActions } from "../utilities/wasApprovalAPIs"
import { getFlexicoTransaction, getFlexicoTemplate } from "src/utilities/FlexicoAPIs";
import { useSelector, useDispatch } from "react-redux";
import moment from 'moment';
import Feedback from "src/generic-components/UserFeedback/Feedback";
import { configureDynamicS3, configureGenericS3, configurePlusAppsync } from "src/context/AuthContextUtility";
import { S3_CONFIG } from "src/constants/AppConstants";
import { setCurrentAppId } from "src/store/userAuthSlice";
import { checkIfSupportAdmin, isMemberOf } from "src/checkPageAccess";
import { isEffectiveSupportAdmin } from 'src/utilities/adminUtils';
import EmbedResults from "src/generic-components/EmbedResults/EmbedResults";
import { getFRISCOTransactions } from "src/Ateam-BI/Templates/Utils/AppActivityUtils";
import { cleanS3PathForDownload } from "src/utilities/S3Utils";
import { convertEpochToPST } from "src/Ateam-BI/Frisco/FilterUtilities";
import EmbedFlexicoParams from "src/generic-components/EmbedResults/EmbedFlexicoParams";
import { getDocumentFromVault } from 'src/Ateam-BI/Vault/VaultAPIs';
import { VAULT_SERVICES } from "src/Ateam-BI/Vault/constants";


const WorkflowInstance = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [item, setItem] = useState([]);
  const [ShowLoadingIcon, setShowLoadingIcon] = useState(false);

  const [activeTabId, setActiveTabId] = useState("details");
  const currentStage = useSelector((globalState) => globalState.auth.currentStage)

  const { workflowInstanceId } = useParams()
  const [title, setTitle] = useState()
  const [description, setDescription] = useState()
  const [status, setStatus] = useState()
  const [createdAt, setCreatedAt] = useState()
  const [requestedBy, setRequestedBy] = useState()
  const [approvers, setApprovers] = useState([])
  const [allowedActions, setAllowedActions] = useState([])
  const [s3FilePath, setS3FilePath] = useState()
  const [s3RawFilePath, setS3RawFilePath] = useState()
  const [s3FileBucket, setS3FileBucket] = useState()
  const [s3FileBucketRegion, setS3FileBucketRegion] = useState()
  const [sourceType, setSourceType] = useState()
  const [workflowLifecycle, setWorkflowLifecycle] = useState([])
  const [entityId, setEntityId] = useState(null)
  const [approvalsRequired, setApprovalsRequired] = useState()
  const [dsInfo, setDsInfo] = useState()
  const [tableItems, setTableItems] = useState([])
  const [columnsList, setColumnsList] = useState([])
  const [showViewFileModal, setShowViewFileModal] = useState(false)
  const [showApproveModal, setShowApproveModal] = useState(false)
  const [showRejectModal, setShowRejectModal] = useState(false)
  const [showDownloadAndView, setShowDownloadAndView] = useState(false)
  const [showMultiLevelApproverModal, setShowMultiLevelApproverModal] = useState(false)
  const [actionComments, setActionComments] = useState('')
  const [isSlicedView, setIsSlicedView] = useState('')
  const [outputResults, setOutputResults] = useState(null)
  const [appId, setAppId] = useState()
  const [subId, setSubId] = useState()
  const [subType, setSubType] = useState()
  const [fileId, setFileId] = useState()
  const [transactionDetails, setTransactionDetails] = useState()
  const [transactionInfo, setTransactionInfo] = useState(null)
  const [flexicoTemplateInfo, setFlexicoTemplateInfo] = useState(null)
  const [isMultiLevelApprover, setIsMultiLevelApprover] = useState(false)
  const [userLdapsList, setUserLdapsList] = useState(null)
  const [approvalButtonText, setApprovalButtonText] = useState('Approve')
  const [isSelfReview, setIsSelfReview] = useState(false)
  const [certificationChecked, setCertificationChecked] = useState(false)
  const [approvalMessage, setApprovalMessage] = useState('')
  const [showApprovalMessageModal, setShowApprovalMessageModal] = useState(false)
  const [hideNonEssentialDetails, setHideNonEssentialDetails] = useState(false)
  const [fileContentExists, setFileContentExists] = useState(false)
  const { breadcrumbItems, generateBreadcrumbs } = useBreadcrumb();

  const currentUser = useSelector((globalState) => globalState.auth.userId)
  const userLDAPS = useSelector((globalState) => globalState.auth.userLDAPS);


  const helpContent = (
    <HelpPanel
      header={
        <div>
          <div></div>
          <h2>Additional Info </h2>
        </div>
      }
    >
      <SpaceBetween size="s">
        {approvers?.map((item) => {
          return (<Alert
            statusIconAriaLabel="info"
            type="info"
            header={item.title}
          >
            <>
              <br />
              <span style={{ fontWeight: "bold" }}>Approvers:</span>
              <ul style={{ listStyleType: "none", padding: "0px", margin: "0px" }}>
                {
                  item.actors.map((i, index) => {
                    if (i.type === 'USER') {
                      return (
                        <li key={index}>
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={"https://phonetool.amazon.com/users/" + i.identifier}
                          >
                            {i.identifier}
                          </a>
                        </li>
                      )
                    } else {
                      return (<li key={index}>{i.identifier}</li>)
                    }
                  })
                }
              </ul>
              <br />
              <b>No of Approvals Required: </b> {item.responsesNeeded}
            </>
          </Alert>)
        })}
      </SpaceBetween>
    </HelpPanel>
  );

  useEffect(() => {
    configurePlusAppsync()
    loadData();
    return () => {
      configureGenericS3()
    };
  }, [currentStage]);

  useEffect(() => {
    setUserLdapsList(userLDAPS?.split(',').map(item => item.trim()))
    return () => {
    };
  }, [userLDAPS]);

  useEffect(() => {

    generateFileContent(s3FilePath, s3FileBucket)

  }, [s3FilePath, s3FileBucket])

  useEffect(() => {

    checkIfUserCanDownloadAndView(approvers, requestedBy)

  }, [approvers, requestedBy])

  useEffect(() => {
    const hasContent = entityId === 'FRISCO' && transactionDetails ? 
      (transactionDetails.rawFilePath || transactionDetails.filePath || transactionDetails.supportingDocuments) :
      s3FilePath;
    setFileContentExists(Boolean(hasContent));
  }, [entityId, transactionDetails, s3FilePath])

  const checkIfUserCanDownloadAndView = async(approvers, requestedBy) => {
    let canShow = false
    let isSupportAdmin = isEffectiveSupportAdmin() || await checkIfSupportAdmin(currentUser, currentStage)
    if(isSupportAdmin){
      canShow = true
    }else if(requestedBy == currentUser){
      canShow = true
    }else{
      for(let i=0;i<approvers.length;i++){
        let approverItem = approvers[i]
        for(let j=0;j<approverItem.actors?.length;j++){
          if(approverItem.actors[j].type == 'USER' && approverItem.actors[j].identifier == currentUser){
            canShow = true
            break
          }else if(approverItem.actors[j].type == 'GROUP'){
              let alias = approverItem.actors[j].identifier?.split('(')[0]
              if(await isMemberOf(currentUser, alias, currentStage)){
                canShow = true
                break
              }
          }
        }
        if(canShow){
          break
        }
      }
    }
    
    setShowDownloadAndView(canShow)
  }

  const setAppIdFromTags = (response) => {
    try {
      let tags = response['workflowInstances'][0]['tags']
      tags.forEach((tag) => {
        if (tag?.key && tag.key == 'app_id') {
          dispatch(setCurrentAppId(tag.value))
        }
      })
    } catch (err) {
    }
  }
  const loadData = async (action = null) => {
    setShowLoadingIcon(true);

    const details = {
      workflowInstanceId: workflowInstanceId,
      stage: currentStage,
      userAlias: currentUser
    }
    const response = await getWasWorkflowById(details)
    setAppIdFromTags(response)
    const workflowInstance = response["workflowInstances"][0]
    const tags = workflowInstance.tags
    const sourceType = tags.find((item) => (item.key === 'source_type'))?.value
    
    // Check for FLEXICO_POST_PROCESS_REVIEW first (takes precedence)
    const hasPostProcessReview = tags.some((item) => item.key === 'source_type' && item.value === 'FLEXICO_POST_PROCESS_REVIEW')
    
    // Update title based on source type
    let displayTitle = workflowInstance.name
    if (hasPostProcessReview) {
      displayTitle = displayTitle.replace('Approval on', 'Review on')
    }
    setTitle(displayTitle)
    setDescription(workflowInstance.description)
    
    // Get approval button text from REVIEW_CONFIG if available
    const reviewConfig = tags.find((item) => (item.key === 'REVIEW_CONFIG'))?.value
    if (reviewConfig) {
      try {
        const config = JSON.parse(reviewConfig)
        if (config.approval_button_text) {
          setApprovalButtonText(config.approval_button_text)
        }
        if (config.post_approval_message) {
          setApprovalMessage(config.post_approval_message)
        }
        if (config.hide_non_essential_details) {
          setHideNonEssentialDetails(config.hide_non_essential_details)
        }
      } catch (e) {
        // Keep default if parsing fails
      }
    }
    
    // Check if this is a self-review
    const isSelfReviewTag = tags.find((item) => (item.key === 'isSelfReview'))?.value
    setIsSelfReview(isSelfReviewTag === 'True')
    
    // Update breadcrumbs with deliverable reference and title
    const deliverableRef = displayTitle || workflowInstanceId;
    const appId = tags.find((item) => (item.key === 'app_id'))?.value
    const processId = tags.find((item) => (item.key === 'process_id'))?.value
    const logicoProcessId = tags.find((item) => (item.key === 'logico_process_id'))?.value
    const flexicoId = tags.find((item) => (item.key === 'flex_id'))?.value
    setAppId(appId)
    await generateBreadcrumbs(null , "Approvals", appId, processId, deliverableRef, logicoProcessId);
    setStatus(workflowInstance.status)
    setCreatedAt(workflowInstance.createdOn)
    setRequestedBy(workflowInstance.createdBy)
    setWorkflowLifecycle(workflowInstance.response_data)
    setEntityId(workflowInstance.entityId)
    const roles = workflowInstance.roles

    const approverLevels = roles.filter((item) => item.name.startsWith('Approver')).map((i) => i.actors)
    const approveStates = workflowInstance.states.map((i) => i.nextStates.filter((item) => (item.action === "Approve"))).map((j) => j[0])
    const approvers = []
    approverLevels.forEach((item, index) => {
      const result = {
        actors: approverLevels[index],
        responsesNeeded: Object.values(approveStates[index].responsesNeeded).reduce((total, currentVal) => total + parseInt(currentVal), 0),
        title: `Level - ${index + 1}${index + 1 === approverLevels.length ? ' (Final Level)' : ''}`
      }
      approvers.push(result)
    })

    setApprovers(approvers)
    // Flitering through the approvers list in each level 
    // To check if the current userAlias or his associated Ldaps are present in both the levels.                 
    const localMultiApprover = approvers.filter(item => item.actors.some(actor => actor.identifier.replace('(ldapGroup)', '') === currentUser || userLdapsList?.includes(actor.identifier.replace('(ldapGroup)', '')))).length > 1;
    setIsMultiLevelApprover(localMultiApprover);
    setS3FilePath(tags.find((item) => (item.key === 'file_path'))?.value)
    setS3RawFilePath(tags.find((item) => (item.key === 'raw_file_path'))?.value)
    setS3FileBucket(tags.find((item) => (item.key === 'file_bucket_name'))?.value)
    setS3FileBucketRegion(tags.find((item) => (item.key === 'file_bucket_region'))?.value)
    setSourceType(sourceType)
    const subId = tags.find((item) => (item.key === 'sub_id'))?.value
    setSubId(subId || processId || logicoProcessId || flexicoId)
    const subTypeLocal = tags.find((item) => (item.key === 'sub_id_type'))?.value
    setSubType(subTypeLocal)
    const fileId = tags.find((item) => (item.key === 'file_id'))?.value
    setFileId(fileId)
    if(fileId && workflowInstance.entityId && workflowInstance.entityId == 'FRISCO'){
      // download transaction details
      getFRISCOTransactions(fileId, function onSuccess(result) {
        setTransactionDetails(result.data.getFRISCOTransactions)
      }, function onFailure(response) {
      })
    }
    if(sourceType == 'FLEXICO_REVIEW' && subTypeLocal == null ){
      setSubType('FLEXICO')
    }
    if(sourceType == 'FLEXICO_REVIEW' || (sourceType == 'RIPPLE_APPROVAL' && subTypeLocal == 'FLEXICO') && fileId){
        // fetch flexico info and show output results
        getFlexicoTransaction(fileId, function onSuccess(result) {
                    const transactionData = result?.data?.getFlexicoTransaction
                    setOutputResults(transactionData?.outputResults)
                    setTransactionInfo(transactionData)
                    
                    // fetch template info
                    if(transactionData?.flexId) {
                      getFlexicoTemplate(transactionData.flexId, function onSuccess(flexicoInfo){
                        setFlexicoTemplateInfo(flexicoInfo.data.getFlexicoTemplateRDS)
                      })
                    }
                }, function onFailure(response) {
                })
    }
    
    const actionsResponse = await getAllowedActions(details)
    setAllowedActions(actionsResponse)
    setShowLoadingIcon(false);
    if (action === 'Approve' && isMultiLevelApprover && actionsResponse?.length > 1) {
      setShowMultiLevelApproverModal(true)
    }
  };


  const performAction = async (action) => {

    setShowLoadingIcon(true)
    const details = {
      eventTriggeredBy: currentUser,
      stage: currentStage,
      eventType: action,    // Possible values: Approve, Reject, Cancel
      workflowInstanceId: workflowInstanceId
    }
    if (actionComments.trim().length >= 1) {
      details['comments'] = actionComments
    }
    const response = await performActionOnWorkflow(details)
    setShowApproveModal(false)
    setShowRejectModal(false)
    
    // Show approval message if available and action is Approve
    if (action === 'Approve' && approvalMessage) {
      setShowApprovalMessageModal(true)
    }
    
    loadData(action)

  };

  const determineModal = (action) => {

    setActionComments('')
    if (action === 'Approve') {
      setShowApproveModal(true)

    } else if (action === 'Reject') {
      setShowRejectModal(true)
    } else if (action === 'Cancel') {
      performAction(action)
    }

  }

  const getReviewerNames = () => {
    if (flexicoTemplateInfo?.approvers) {
      return flexicoTemplateInfo.approvers
        .filter(approver => approver.column_index === 0)
        .map(approver => approver.alias)
        .join(', ') || 'reviewer'
    }
    return approvers?.filter(item => item.title.includes('Level - 1'))
      .map(item => item.actors.filter(actor => actor.type === 'USER')
      .map(actor => actor.identifier).join(', ')).join(', ') || 'reviewer'
  }

  const getApproverNames = () => {
    if (flexicoTemplateInfo?.approvers) {
      return flexicoTemplateInfo.approvers
        .filter(approver => approver.column_index === 1)
        .map(approver => approver.alias)
        .join(', ') || 'approver'
    }
    return approvers?.filter(item => item.title.includes('Final Level'))
      .map(item => item.actors.filter(actor => actor.type === 'USER')
      .map(actor => actor.identifier).join(', ')).join(', ') || 
      approvers?.map(item => item.actors.filter(actor => actor.type === 'USER')
      .map(actor => actor.identifier).join(', ')).join(', ') || 'approver'
  }

  const downloadFile = async (path, bucket) => {
    if (bucket) {
      let region = s3FileBucketRegion ? s3FileBucketRegion : S3_CONFIG.find((c) => c.environment === currentStage)?.region
      configureDynamicS3(bucket, region)
    }
    if (path) {
      let paths = path?.split(',')
      if (paths?.length > 0) {
        for (let i = 0; i < paths.length; i++) {
          let fn = paths[i]
          let prefix = 'public/'
          let service;
          let arr = fn.split('.')
          let contentType = arr[arr.length - 1]
          if (sourceType && sourceType.includes("FRISCO")) {
            // fn = fn.replace('frisco/', '')
            prefix = 'frisco/'
            service = VAULT_SERVICES.FRISCO
          } else if (sourceType && sourceType.includes("FLEXICO_LOAD_APPROVAL")) {
            // fn = fn.replace('flexico/', '')
            prefix = 'flexico/'
            service = VAULT_SERVICES.FLEXICO
          } else if (sourceType && sourceType.includes("LOGICO_LOAD_APPROVAL")) {
            // fn = fn.replace('logico/', '')
            prefix = 'logico/'
            service = VAULT_SERVICES.LOGICO
          } else {
            fn = fn.replace('public/', '')
          }
          fn = cleanS3PathForDownload(fn)
            
          let document = await getDocumentFromVault(contentType, service, {"file_path": `${decodeURIComponent(fn).replaceAll('ABCPLUSTEMP', '+')}`, ...(subId && {"service_id": `${subId}`}), ...(appId && {"app_id": `${appId}`})})
          let fileURL = document?.fileUrl

          window.open(fileURL);
        }
      }
    }
    else {
      window.open("");
    }

  }

  const generateFileContent = async (path, bucket) => {
    if (bucket) {
      let region = s3FileBucketRegion ? s3FileBucketRegion : S3_CONFIG.find((c) => c.environment === currentStage)?.region
      configureDynamicS3(bucket, region)
    }
    if (path) {
      let fn = path
      let prefix = 'public/'
      let service;
      let arr = fn.split('.')
      let contentType = arr[arr.length - 1]

      if (sourceType && sourceType.includes("FRISCO")) {
        // fn = fn.replace('frisco/', '')
        prefix = 'frisco/'
        service = VAULT_SERVICES.FRISCO
      } else if (sourceType && sourceType.includes("FLEXICO_LOAD_APPROVAL")) {
        // fn = fn.replace('flexico/', '')
        prefix = 'flexico/'
        service = VAULT_SERVICES.FLEXICO
      } else if (sourceType && sourceType.includes("LOGICO_LOAD_APPROVAL")) {
        // fn = fn.replace('logico/', '')
        prefix = 'logico/'
        service = VAULT_SERVICES.LOGICO
      } else {
        fn = fn.replace('public/', '')
      }
    
      // const fileURL = await Storage.get(fn, { level: 'public', customPrefix: { public: prefix }, expires: 60 });
      let document = await getDocumentFromVault(contentType, service, {"file_path": `${fn}`, ...(subId && {"service_id": `${subId}`}), ...(appId && {"app_id": `${appId}`})})
      let fileURL = document?.fileUrl

      let csvdata = await d3.csv(fileURL).then((result) => {
        const slicedArray = result.slice(0, 100);
        setIsSlicedView(result.length > 100)
        setDsInfo(slicedArray);
        if (result?.columns) {
          const definitions = result?.columns.map(colName => ({
            id: colName,
            header: colName,
            cell: item => item[colName] || '-'
          }))
          setColumnsList(definitions)
        }

        // setState here..
      });
    }
  }

  const viewFile = () => {
    setShowViewFileModal(true)
  }

  const downloadSupportingDocuments = async (item, index) => {
    let files = item.supportingDocuments
    configureDynamicS3(item.bucket_name, item.region || 'us-east-1')
      let filefn = files[index]
      let arr = filefn.split('.')
      let contentType = arr[arr.length - 1]
      // sometimes FRISCO saved the supporting docs to the actual folder dedicated to fileID, but there is an issue where the uris saved are stage path whoch will not exist. Hence, backwards compatibility for files uploaded previously(before the fix)
      if (filefn?.includes('stage/')) {
        filefn = filefn.replace('stage/', 'source/')
      }
      let prefix = 'frisco/'
      let service = VAULT_SERVICES.FRISCO;
      // const result = await Storage.get(decodeURIComponent(cleanS3PathForDownload(filefn)).replaceAll('ABCPLUSTEMP', '+'), { level: 'public', customPrefix: { public: prefix }, expires: 60 });
      let document = await getDocumentFromVault(contentType, service, {"file_path": `${decodeURIComponent(cleanS3PathForDownload(filefn)).replaceAll('ABCPLUSTEMP', '+')}`, ...(subId && {"service_id": `${subId}`}), ...(appId && {"app_id": `${appId}`})})
      let fileURL = document?.fileUrl
      window.open(fileURL);
    
  }

  const getFileViewByEntity = (entityId) => {
    if(entityId == 'FRISCO'){
      return friscoFileView
    }else {
      return defaultView
    }
  }

  const friscoFileView = (
    <>
    {
        transactionDetails ? <Box>
          <SpaceBetween direction="horizontal" size="m">
            {
              transactionDetails.rawFilePath && transactionDetails.bucket_name &&
              <Button
                variant="primary"
                iconName="download"
                onClick={() => downloadFile(transactionDetails.rawFilePath, s3FileBucket)}
                disabled={!showDownloadAndView}
              >  Raw file</Button>
            }
            {
              transactionDetails.filePath && transactionDetails.bucket_name &&
              <Button variant="primary"
                iconName="download"
                onClick={() => downloadFile(transactionDetails.filePath, transactionDetails.bucket_name)}
                disabled={!showDownloadAndView}
              >
                Download
              </Button>
            }

            {
              transactionDetails.filePath && transactionDetails.bucket_name && transactionDetails.filePath?.endsWith('.csv') &&
              <Button
                iconName="search"
                onClick={() => viewFile()}
                disabled={!showDownloadAndView}
              >
                View
              </Button>
            }
            {
              transactionDetails.supportingDocuments && transactionDetails.bucket_name && 
              <ExpandableSection headerText="supporting docs">
                  <SpaceBetween direction="vertical">
                    {transactionDetails.supportingDocuments.map((document, index) => {
                      // Extract filename from the path
                      const fileName = document?.split('/').pop();

                      return (
                        <Button
                          iconName="download"
                          variant="inline-link"
                          onClick={() => downloadSupportingDocuments(transactionDetails, index)}
                          disabled={!showDownloadAndView}>
                          {fileName}
                        </Button>
                      );
                    })}
                  </SpaceBetween>
                  
              </ExpandableSection>
              
            }
          </SpaceBetween>
        </Box> : defaultView
    }
    </>
  )

  const defaultView = (
    <>
      {
        s3FilePath ?
          <Box>
            <SpaceBetween direction="horizontal" size="l">
              <Button variant="primary"
                iconName="download"
                onClick={() => downloadFile(s3FilePath, s3FileBucket)}
                disabled={!showDownloadAndView}
              >
                Download
              </Button>
              {
                s3RawFilePath ?
                  <Button
                    variant="primary"
                    iconName="download"
                    onClick={() => downloadFile(s3RawFilePath, s3FileBucket)}
                    disabled={!showDownloadAndView}
                  > Download raw file</Button> : <></>
              }
              {
                s3FilePath?.endsWith('.csv') ? <Button
                  iconName="search"
                  onClick={() => viewFile()}
                  disabled={!showDownloadAndView}
                >
                  View
                </Button> : <></>
              }

            </SpaceBetween>
          </Box> : <></>
      }
    </>
  )

  const renderActionSection = (stepNumber) => {
    return status === 'pending' ? (
      <Grid gridDefinition={fileContentExists ? [{ colspan: 2 }, { colspan: 10 }] : [{ colspan: 12 }]}>
        {fileContentExists && (
          <Box
            fontSize="display-l"
            fontWeight="bold"
            color="text-body-secondary"
          >
            {stepNumber}
          </Box>
        )}
        <Box>
          <SpaceBetween direction="vertical" size="l">
            <Box color="text-body-secondary">
              Perform Action on workflow after reviewing.
            </Box>
            {allowedActions.length === 0 ?
              <Box color="text-body-secondary">
                <br />
                You have no action pending or not authorized to peform action on this workflow!
              </Box>
              :
              <>
                {isSelfReview && allowedActions.includes('Approve') && (
                  <Alert statusIconAriaLabel="Info" header="">
                    <Checkbox
                      onChange={({ detail }) => setCertificationChecked(detail.checked)}
                      checked={certificationChecked}
                    >
                      <strong>I, {currentUser} (uploader), certify that the deliverable has been reviewed by {getReviewerNames()} (reviewer) and approved by {getApproverNames()} (approver).</strong>
                    </Checkbox>
                  </Alert>
                )}
                <Box>
                  <SpaceBetween direction="horizontal" size="l">
                    {allowedActions.filter(action => !(isSelfReview && action === 'Reject')).map((action) => (
                      <Button
                        variant={action === 'Approve' ? "primary" : "normal"}
                        iconAlign="right"
                        iconName={action === 'Approve' ? "thumbs-up" : action === 'Reject' ? "thumbs-down" : "status-negative"}
                        onClick={() => { determineModal(action) }}
                        disabled={action === 'Approve' && isSelfReview && !certificationChecked}
                      >
                        {action === 'Approve' && sourceType == 'FLEXICO_REVIEW' ? "Submit" : 
                         action === 'Approve' ? approvalButtonText : action}
                      </Button>
                    ))}
                  </SpaceBetween>
                </Box>
              </>
            }
          </SpaceBetween>
          <br></br>
        </Box>
      </Grid>
    ) : (
      <Box color="text-body-secondary" variant="h2">
        <Icon name="lock-private" />
        <br></br>
        Action on this workflow is taken, no further action required!
      </Box>
    );
  };



  const onFollowHandler = (ev) => {
    ev.preventDefault();
    if (ev.detail.href) {
      history.push(ev.detail.href);
    }
  };

  const content = (
    <div>
      <Box>
        <Box padding="m">
          <BreadcrumbGroup
            items={breadcrumbItems}
            onFollow={onFollowHandler}
          />
        </Box>
        <Box>
          <Grid
            gridDefinition={[{ colspan: 12 }]}
          >
            <SpaceBetween size="xxl">
              <div>
                <Container
                  header={
                    <Header
                      variant="awsui-h1-sticky"
                      actions={
                        <SpaceBetween direction="horizontal" size="xs">
                          <Button
                            variant="normal"
                            iconName="close"
                            onClick={() => {
                              history.push("/");
                            }}
                          ></Button>
                        </SpaceBetween>
                      }
                    >
                      Workflow Details
                    </Header>
                  }
                >
                  <ColumnLayout columns={3}>
                    {!hideNonEssentialDetails && (
                      <Box>
                        <Box variant="awsui-key-label">Workflow Instance Id</Box>
                        <Box>{workflowInstanceId}</Box>
                      </Box>
                    )}
                    <Box>
                      <Box variant="awsui-key-label">Workflow Title</Box>
                      <Box>{title}</Box>
                    </Box>
                    <Box>
                      <Box variant="awsui-key-label">Description</Box>
                      <Box>{description}</Box>
                    </Box>
                    {!hideNonEssentialDetails && (
                      <Box>
                        <Box variant="awsui-key-label">Status</Box>
                        <Box>{status} &nbsp;
                          {status === 'completed' ? <Icon name="thumbs-up" variant="success" /> :
                            status === 'rejected' ? <Icon name="thumbs-down" variant="error" /> :
                              status === 'cancelled' ? <Icon name="status-negative" /> :
                                status === 'pending' ? <Icon name="status-in-progress" /> :
                                  <></>
                          }
                        </Box>
                      </Box>
                    )}
                    <Box>
                      <Box variant="awsui-key-label">Created At</Box>
                      <Box>{convertEpochToPST(Number(createdAt))}</Box>
                    </Box>
                    <Box>
                      <Box variant="awsui-key-label">Requested By</Box>
                      <img
                        alt=""
                        className="rounded-circle"
                        src={
                          "https://badgephotos.corp.amazon.com/?uid=" +
                          `${requestedBy}`
                        }
                        width={20}
                        height={20}
                      />
                      &nbsp;
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={"https://phonetool.amazon.com/users/" + requestedBy}
                      >
                        {requestedBy}
                      </a>
                    </Box>
                  </ColumnLayout>
                </Container>
              </div>
              <div>
                {
                  (entityId == 'FLEXICO' || (sourceType == 'RIPPLE_APPROVAL' && subType == 'FLEXICO') || sourceType == 'FLEXICO_REVIEW') && <EmbedFlexicoParams fileId={fileId} transactionInfo={transactionInfo} flexicoTemplateInfo={flexicoTemplateInfo}></EmbedFlexicoParams>
                }
              </div>
              <div>
                {
                  outputResults ? <ExpandableSection defaultExpanded variant="container" headerText="Results" headerInfo={<Link target='_blank' href={`/${subType}/file/${fileId}`} external={true} variant="info">{sourceType == 'FLEXICO_REVIEW' || (sourceType == 'RIPPLE_APPROVAL' && subType ) && fileId? `${subType.toLowerCase()} run details` : ''}</Link>}>
                    <EmbedResults outputResults={outputResults} showSave={status === 'pending'} isReview={sourceType == 'FLEXICO_REVIEW'} showAllAsTab={true} serviceId={subId} appId={appId}></EmbedResults>
                  </ExpandableSection> : <></>
                }

              </div>
              <div>
                <Box>
                  <br></br>

                  <SpaceBetween direction="horizontal" size="xs">
                    <Button
                      variant="normal"
                      iconName="refresh"
                      onClick={() => loadData()}
                    >
                      Refresh
                    </Button>
                    {ShowLoadingIcon ? (
                      <Modal visible={ShowLoadingIcon}>
                        <Box>
                          <Spinner></Spinner>
                          Loading...
                        </Box>
                      </Modal>
                    ) : (
                      <Box></Box>
                    )}
                  </SpaceBetween>
                  <br />

                  <Tabs
                    variant="container"
                    activeTabId={activeTabId}
                    onChange={({ detail }) => setActiveTabId(detail.activeTabId)}
                    tabs={[
                      {
                        label: "Next Steps",
                        id: "details",
                        content: (
                          <>
                            <Modal
                              onDismiss={() => { setShowViewFileModal(false) }}
                              visible={showViewFileModal}
                              size="max"
                              header={
                                <SpaceBetween direction="vertical">
                                  <Box variant="h2">Review File 
                                  {
                                    columnsList.length>0 ?<></>:<Spinner></Spinner>
                                  }
                                  </Box>
                                  {
                                    isSlicedView?
                                    <span className="last_updated"> Displaying first 100 rows only. Please download the file for full content.</span>:<></>
                                  }
                                </SpaceBetween>
                              }
                              footer={
                                <Box float="right">
                                  <>
                                    <Button variant={"primary"} onClick={() => setShowViewFileModal(false)}>Close</Button>
                                  </>
                                </Box>

                              }
                            >
                              <Table
                                columnDefinitions={columnsList}
                                items={dsInfo}
                                stickyHeader={true}
                                resizableColumns={true}
                              >

                              </Table>
                            </Modal>

                            <Modal
                              onDismiss={() => {
                                setShowApproveModal(false)
                                setActionComments('')
                              }}
                              visible={showApproveModal}
                              header={<Header
                                variant="h3"
                                description="Provide any comments you may have"
                              >
                                {approvalButtonText} <Icon name="thumbs-up-filled" variant="success" />
                              </Header>}
                              footer={
                                <Box float="right">
                                  <SpaceBetween direction="horizontal" size="xs">
                                    <Button onClick={() => {
                                      setShowApproveModal(false)
                                      setActionComments('')
                                    }}>Go Back</Button>
                                    <Button variant={"primary"}
                                      iconAlign="right"
                                      iconName="thumbs-up"
                                      onClick={() => { performAction('Approve') }}>{approvalButtonText}</Button>
                                  </SpaceBetween>
                                </Box>

                              }
                            >
                              <FormField>
                                <Textarea
                                  onChange={({ detail }) => setActionComments(detail.value)}
                                  value={actionComments}
                                  placeholder="Add Comments (Optional)"
                                />
                              </FormField>
                            </Modal>

                            <Modal
                              onDismiss={() => {
                                setShowMultiLevelApproverModal(false)
                              }}
                              visible={showMultiLevelApproverModal}
                              header={<Header
                                variant="h3"
                                description="You are a part of Approvers in the next level as well. Do you want to take action for the next level now?"
                              >
                                Proceed with Next Level
                              </Header>}
                              footer={
                                <Box float="right">
                                  <SpaceBetween direction="horizontal" size="xs">
                                    <Button variant={"primary"}
                                      onClick={() => { setShowMultiLevelApproverModal(false) }}>Continue</Button>
                                  </SpaceBetween>
                                </Box>

                              }
                            >
                            </Modal>

                            <Modal
                              onDismiss={() => {
                                setShowRejectModal(false)
                                setActionComments('')
                              }}
                              visible={showRejectModal}
                              header={<Header
                                variant="h3"
                                description="Please note that rejecting this request will end workflow and prevent others from taking action.
                        After rejecting there is no way to reactivate/restart this request and a new request will need to be created. If you are sure you want to reject this request, please proceed below."
                              >
                                Reject <Icon name="thumbs-down-filled" variant="error" />
                              </Header>}
                              footer={
                                <Box float="right">
                                  <SpaceBetween direction="horizontal" size="xs">
                                    <Button onClick={() => {
                                      setShowRejectModal(false)
                                      setActionComments('')
                                    }}>Go Back</Button>
                                    <Button variant={"primary"}
                                      iconAlign="right"
                                      iconName="thumbs-down" onClick={() => { performAction('Reject') }}>Reject</Button>
                                  </SpaceBetween>
                                </Box>

                              }
                            >
                              <FormField>
                                <Textarea
                                  onChange={({ detail }) => setActionComments(detail.value)}
                                  value={actionComments}
                                  placeholder="Add Comments (Optional)"
                                />
                              </FormField>
                            </Modal>

                            <Modal
                              onDismiss={() => setShowApprovalMessageModal(false)}
                              visible={showApprovalMessageModal}
                              header={<Header variant="h3">Success</Header>}
                              footer={
                                <Box float="right">
                                  <Button variant="primary" onClick={() => setShowApprovalMessageModal(false)}>Close</Button>
                                </Box>
                              }
                            >
                              <Box>{approvalMessage}</Box>
                            </Modal>
                            {fileContentExists ? (
                              <ColumnLayout columns={2} borders="vertical">
                                <Box>
                                    <Grid gridDefinition={[{ colspan: 2 }, { colspan: 10 }]}>
                                    <Box
                                      fontSize="display-l"
                                      fontWeight="bold"
                                      color="text-body-secondary"
                                    >
                                      1
                                    </Box>
                                    <Box>
                                      <SpaceBetween direction="vertical" size="l">
                                        <Box color="text-body-secondary">
                                          Download or view the file to review before taking an
                                          action
                                        </Box>
                                        {
                                          getFileViewByEntity(entityId)
                                        }
                                      </SpaceBetween>

                                      <br></br>
                                    </Box>
                                  </Grid>
                                  
                                </Box>
                                <Box>
                                {renderActionSection('2')}
                              </Box>
                              </ColumnLayout>
                            ) : (
                              <Grid gridDefinition={[{ colspan: 6 }]}>
                                <Box>
                                  {renderActionSection('1')}
                                </Box>
                              </Grid>
                            )}

                          </>
                        ),
                      },
                    ]}
                  />

                </Box>
              </div>

              <div>
                <Container
                  header={
                    <Header
                      variant="h3"
                    >
                      Workflow Lifecycle
                    </Header>
                  }
                >
                  <Box><ul style={{ listStyleType: "none", paddingLeft: "0px" }}><SpaceBetween direction="horizontal" size="m">{workflowLifecycle.map((action, index) => {
                    if (action.response === 'Approve') {
                      return (
                        <li key={index}>
                          <Alert
                            statusIconAriaLabel="success"
                            type="success"
                            header={`Approved`}
                          >
                            by&nbsp;
                            <a
                              target="_blank"
                              rel="noopener noreferrer"
                              href={"https://phonetool.amazon.com/users/" + action.userAlias}
                            >
                              {action.userAlias}
                            </a>
                            &nbsp;at {convertEpochToPST(Number(action.timeStamp))}
                            {action?.comments ?
                              <ExpandableSection headerText="User comments" variant="navigation">
                                {action.comments}
                              </ExpandableSection>
                              :
                              <></>
                            }
                            {action?.resolvedGroups && action?.resolvedGroups.length >= 1 ?
                              <ExpandableSection headerText="Resolved groups" variant="navigation">
                                <Box> <ul style={{ listStyleType: "none", paddingLeft: "0px" }}>
                                  {action.resolvedGroups.map((item) => (
                                    <li key={item}>{item}</li>
                                  ))}
                                </ul></Box>
                              </ExpandableSection>
                              :
                              <></>
                            }
                          </Alert>
                          <br />
                        </li>
                      )
                    } else if (action.response === 'Reject') {
                      return (
                        <li key={index}>
                          <Alert
                            statusIconAriaLabel="error"
                            type="error"
                            header={`Rejected`}
                          >
                            by&nbsp;
                            <a
                              target="_blank"
                              rel="noopener noreferrer"
                              href={"https://phonetool.amazon.com/users/" + action.userAlias}
                            >
                              {action.userAlias}
                            </a>
                            &nbsp;at {convertEpochToPST(Number(action.timeStamp))}
                            {action?.comments ?
                              <ExpandableSection headerText="User comments" variant="navigation">
                                {action.comments}
                              </ExpandableSection>
                              :
                              <></>
                            }
                            {action?.resolvedGroups && action?.resolvedGroups.length >= 1 ?
                              <ExpandableSection headerText="Resolved groups" variant="navigation">
                                <Box> <ul style={{ listStyleType: "none", paddingLeft: "0px" }}>
                                  {action.resolvedGroups.map((item) => (
                                    <li key={item}>{item}</li>
                                  ))}
                                </ul></Box>
                              </ExpandableSection>
                              :
                              <></>
                            }
                          </Alert>
                          <br />
                        </li>
                      )
                    } else if (action.response === 'Cancel') {
                      return (
                        <li key={index}>
                          <Alert
                            statusIconAriaLabel="warning"
                            type="warning"
                            header={`Canceled`}
                          >
                            by&nbsp;
                            <a
                              target="_blank"
                              rel="noopener noreferrer"
                              href={"https://phonetool.amazon.com/users/" + action.userAlias}
                            >
                              {action.userAlias}
                            </a>
                            &nbsp;at {convertEpochToPST(Number(action.timeStamp))}
                          </Alert>
                          <br />
                        </li>
                      )
                    } else if (action.response === null) {
                      return (
                        <li key={index}>
                          <Alert
                            statusIconAriaLabel="info"
                            type="info"
                            header={`Created`}
                          >
                            by&nbsp;
                            <a
                              target="_blank"
                              rel="noopener noreferrer"
                              href={"https://phonetool.amazon.com/users/" + action.userAlias}
                            >
                              {action.userAlias}
                            </a>
                            &nbsp;at {convertEpochToPST(Number(action.timeStamp))}
                          </Alert>
                          <br />
                        </li>
                      )
                    }

                  })}</SpaceBetween></ul></Box>
                </Container>
              </div>
            </SpaceBetween>
          </Grid>
        </Box>
        <Box>

        </Box>
        <br />
        <Feedback appId={'Generic'} pageId={`Approval_details_${workflowInstanceId}`} userId={currentUser} parentId={"null"} level={0} limit={1}></Feedback>

      </Box>
    </div>
  );
  return (
    <AppLayout
      content={content}
      headerSelector="#TopBar"
      navigationHide={true}
      tools={helpContent}
      maxContentWidth={Number.MAX_VALUE}
      headerVariant="high-contrast"
    ></AppLayout>
  );
};

export default WorkflowInstance;
